<template>
    <div class="login-warp">
        <div class="container">
            <p class="f18 t-c pb30">俺来也合作平台</p>
            <el-form size="mini" :model="loginForm" :rules="rules" ref="loginForm">
                <el-form-item prop="way">
                    <el-select class="w100p" v-model="loginForm.login_type">
                        <el-option label="账号登录" value="1"></el-option>
                        <el-option label="手机号登录" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <!--账号登录-->
                <div v-if="loginForm.login_type == 1">
                    <el-form-item prop="username">
                        <el-input v-model="loginForm.username" auto-complete="off" placeholder="用户名"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="8~16位包含数字、大小写字母、特殊符号其中两种"></el-input>
                    </el-form-item>
                    <el-form-item prop="imgCaptcha">
                        <el-input v-model="loginForm.imgCaptcha" auto-complete="off" placeholder="验证码">
                            <template slot="append">
                                <img :src="imgCaptchaUrl" height="28" alt="" @click="getImgCaptcha()" class="cursor" id="imgCaptcha">
                            </template>
                        </el-input>
                    </el-form-item>
                </div>
                <!--手机号登录-->
                <div v-if="loginForm.login_type == 2">
                    <el-form-item prop="mobile">
                        <el-input v-model="loginForm.mobile" auto-complete="off" placeholder="手机号"></el-input>
                    </el-form-item>
                    <el-form-item prop="captcha" required>
                        <el-input v-model="loginForm.captcha" auto-complete="off" placeholder="验证码">
                            <template slot="append">
                                <el-button type="text" :loading="loading1" :disabled="smsBtnDisabled" @click="smsSend()">{{smsBtn}}</el-button>
                            </template>
                        </el-input>
                    </el-form-item>
                </div>
                <el-form-item>
                    <el-button type="primary" :loading="loading" @click="submitForm('loginForm')">登录</el-button>
                </el-form-item>
            </el-form>
        </div>
        <footer>
            <div style="padding: 10px 0;text-align: center;font-size: 12px">
                <div> © Copyright 2015-2022 IMC AII Rights Reserved</div>
                <div>
                    俺来也(上海)网络科技有限公司
                    <a style="color: #1E80FF" href="https://beian.miit.gov.cn/" target="_blank">沪ICP备14051190号-7</a>
                    <img src="http://website.anlaiye.com/uploadfile/image/20220721/20220721090341_79922.png" alt="" style="width: 20px;vertical-align: middle">
                    <a style="color: #1E80FF" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402003336" target="_blank">沪公网安备31010402003336号</a>
                </div>
                <div>客服电话:400-6869-933</div>
            </div>
        </footer>
    </div>
</template>

<script>
    import request from 'superagent';
    import store from "../../store";
    import router, {systemRouterMap, headOfficeRouterMap, saasRouterMap} from "../../config/routes";

    export default {
        data() {
            var checkMobile = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入手机号'));
                }
                if (!this.$valid.mobile(value)) {
                    callback(new Error('请输入正确格式的手机号'));
                }
                callback();
            };
            var checkPassword = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入密码'));
                }
                if (!this.$valid.password(value)) {
                    callback(new Error('请输入6-20位字母或者数字密码'));
                }
                callback();
            };
            return {
                smsBtn: '发送验证码',//发送验证码按钮
                smsBtnDisabled: false,//默认可点击
                waitingTime: 60,//
                imgCaptchaUrl: '',
                imgCaptchaKey: '',
                loading: false,
                loading1: false,
                loginForm: { //表单字段
                    login_type: '1',
                    username: '',
                    password: '',
                    mobile: '',
                    captcha: '',
                    imgCaptcha: ''
                },
                rules: {
                    mobile: [
                        { validator: checkMobile, trigger: 'blur'  }
                    ],
                    captcha: [
                        { required: true, message: '请输入短信验证码', trigger: 'blur' },
                    ],
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                    ],
                    password: [
                        { validator: checkPassword, trigger: 'blur' },
                    ],
                    imgCaptcha: [
                        { required: true, message: '请输入图形验证码', trigger: 'blur' },
                    ]
                }
            };
        },
        watch: {
            'loginForm.login_type': function () {
                this.$refs.loginForm.resetFields();
            }
        },
        created() {
            this.$store.commit('SET_ISLOGOUT', false);
            this.getImgCaptcha();
            document.onkeydown = (event) => {
                var e = event || window.event || arguments.callee.caller.arguments[0];
                if (e && e.keyCode == 13) {
                    this.submitForm('loginForm');
                }
            }
        },
        methods: {
            //图形验证码
            getImgCaptcha() {
                this.$api.get(this.$apiUrl.refreshImage,{},(res)=>{
                    this.imgCaptchaUrl = res.data.image;
                    this.imgCaptchaKey = res.data.key;
                })
            },
            //发送验证码
            smsSend () {
                this.$refs.loginForm.validateField('mobile',(errMsg) =>{
                    if(errMsg.length == 0){
                        this.loading1 = true;
                        this.smsBtnDisabled = true;
                        this.smsBtn = this.waitingTime + 's';
                        var inter = setInterval(() => {
                            this.waitingTime--;
                            this.smsBtn = this.waitingTime + 's';
                            if(this.waitingTime === 0) {
                                this.smsBtn = '重新获取';
                                this.smsBtnDisabled = false;
                                this.waitingTime = 60;
                                clearInterval(inter);
                            }
                        },1000);
                        let params = {
                            mp: this.loginForm.mobile,
                            account_type: '1'
                        };
                        this.$api.get(this.$apiUrl.sendSms,params,()=>{
                            this.loading1 = false;
                            this.$message.success('发送成功');
                        },()=>{
                            this.loading1 = false;
                            this.$message.error('发送失败，请稍后再试');
                        })
                    }
                });
            },
            //提交表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        let params;
                        if(this.loginForm.login_type == 1){
                            //账号登录
                            params = {
                                account_type: '1',
                                login_type: parseInt(this.loginForm.login_type),
                                account: this.loginForm.username,
                                password: this.loginForm.password,
                                image_captcha: this.loginForm.imgCaptcha,
                                key: this.imgCaptchaKey
                            };
                        }else{
                            //手机号登录
                            params = {
                                account_type: '1',
                                login_type: this.loginForm.login_type,
                                mp: this.loginForm.mobile,
                                mobile_num: this.loginForm.captcha
                            };
                        }
                        this.$api.post(this.$apiUrl.login,params,(res)=>{
                            this.loading = false;
                            // console.log(res);
                            //保存用户id
                            localStorage.setItem('accountInfo',JSON.stringify(res.data));
                            localStorage.setItem('token',res.data.token);
                            localStorage.setItem('userId',res.data.account_id);
                            localStorage.setItem('userName',res.data.true_name);
                            // type 1:学校账号，2：公司账号，3：加盟账号，4：集团账号（总对总）
                            localStorage.setItem('type',res.data.type);
                            // account_type 1：商户管理员 2：店铺管理员
                            localStorage.setItem('accountType',res.data.account_type);
                            localStorage.setItem('account',res.data.account);
                            localStorage.setItem('avatar',res.data.pic);
                            //localStorage.setItem('routers',JSON.stringify(res.data.menu));

                            this.$store.commit('SET_TOKEN',res.data.token);
                            this.$store.commit('SET_UERID',res.data.account_id);
                            this.$store.commit('SET_USERNAME', res.data.true_name);
                            this.$store.commit('SET_TYPE', res.data.type);
                            this.$store.commit('SET_ACCOUNTTYPE', res.data.account_type);
                            this.$store.commit('SET_AVATAR', res.data.pic);
                            this.$store.commit('SET_ACCOUNT', res.data.account);
                            //this.$store.commit('SET_ROUTERS',res.data.menu);


                            localStorage.setItem('domain',res.data.domain);
                            // this.$message.success('登录成功');

                            //获取店铺 公司
                            this.$api.post(this.$apiUrl.getSubListByToken,{is_need_commercial: 1,is_need_shop: 1},(res2)=>{
                                let commercials = [],
                                    shops = [];
                                if(res2.data.commercial_ids){
                                    for(let k in res2.data.commercial_ids){
                                        commercials.push({id:k,name:res2.data.commercial_ids[k]});
                                    }
                                }
                                if(res2.data.shop_ids){
                                    for(let k in res2.data.shop_ids){
                                        shops.push({id:k,name:res2.data.shop_ids[k]});
                                    }
                                }
                                localStorage.setItem('commercials',JSON.stringify(commercials));
                                localStorage.setItem('shops',JSON.stringify(shops));
                                localStorage.setItem('schoolId',res2.data.school_id);
                                this.$store.commit('SET_SCHOOLID', res2.data.school_id);

                                if(res.data.last_pwd_alert){
                                    this.$message({
                                        showClose: true,
                                        message: '您已经三个月没修改密码了，请尽快修改密码～',
                                        type: 'warning',
                                        duration: 6000
                                    });
                                }
                                this.$store.commit('TOGGLE_REFRESH', false);
                                //1 学校 2 公司 3 加盟 4 总对总商户 5 代理商
                                if (res.data.type == 4) {
                                    // 总对总
                                    this.$router.$addRoutes(headOfficeRouterMap);
                                } else if(res.data.type == 5){
                                    // 代理商
                                    this.$router.$addRoutes(saasRouterMap);
                                } else {
                                    this.$router.$addRoutes(systemRouterMap);
                                }
                                if (res.data.type == 2) {
                                    this.$router.push({ path: '/dining/info' })
                                }else{
                                    this.$router.push({ path: '/' });
                                }
                                // else{
                                //     this.$router.push({ path: '/dashboard/userinfo' })
                                // }
                            })
                        },(res)=>{
                            this.loading = false;
                            //图形验证码刷新
                            if(this.loginForm.login_type == 1){
                                this.getImgCaptcha();
                            }
                            this.$message.error(res.message);
                        })

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .el-input-group__append{
        img{
            vertical-align: middle;
        }
    }
</style>


// WEBPACK FOOTER //
// login.vue?251bc345